export default {
  lang: {
    shortWeekDays: ['一', '二', '三', '四', '五', '六', '日'],
    shortMonths: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
    ],
  },
};
